@use '@design/bapf-pattern-library/source/sass/globals' as *;
@use '@design/bapf-pattern-library/source/sass/vendor/bootstrap';

// alles eingestellt, jetzt folgen unsere Patterns
@use '@design/bapf-pattern-library/source/sass/patterns/button';
@use '@design/bapf-pattern-library/source/sass/patterns/link';
@use '@design/bapf-pattern-library/source/sass/patterns/copytext';
@use '@design/bapf-pattern-library/source/sass/patterns/collapsible';
@use '@design/bapf-pattern-library/source/sass/patterns/modal';
@use '@design/bapf-pattern-library/source/sass/patterns/form';

.initializing {
  display: none;
}

.ba-copytext {
  margin-bottom: 1.5rem;
}

.ba-progress-form-area {
  flex-basis: 100%;
  max-width: 100%;

  .form-check.always-checked-box {
    display: inline-flex;

    span.ba-icon.ba-icon-check {
      align-self: center;
    }

  }
}

.ba-consent-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

@include media-breakpoint-down(sm) {
  .ba-consent-container {
    flex-direction: column;
  }
}
